﻿const possessionsState = [];
const metaDataState = {
    meta: []
};


export const possessionsData = (state = possessionsState, action) => {
    switch (action.type) {
        case 'FETCH_POSSESSIONS_STARTED':
            return { ...state, dataLoading: true };
        case 'FETCH_POSSESSIONS_COMPLETE':
            return { ...state, dataLoading: false, ...action.data };
        default:
            return state;
    }
}

export const metaData = (state = metaDataState, action) => {
    switch (action.type) {
        case 'FETCH_METADATA':
            return { ...state, meta: action.data };
        default:
            return state;
    }
}
